<template>
  <div>
    <div class="invite-friend-list-overlay__backdrop" @click="$emit('close')"></div>
    <div class="invite-friend-list-overlay__panel">
      <div class="invite-friend-list-overlay__header">
        <h2 class="invite-friend-list-overlay__title">초대한 친구 현황</h2>
        <button
          type="button"
          class="invite-friend-list-overlay__close"
          @click="$emit('close')"
        >
          <img
            class="invite-friend-list-overlay__close-icon"
            src="@/assets/home/icn_close.png"
          />
        </button>
      </div>
      <div class="invite-friend-list-overlay__content">
        <img
          class="invite-friend-list-overlay__hifive"
          src="@/assets/home/img_hifive.png"
        />
        <p class="invite-friend-list-overlay__lead">초대한 친구들의 현황을<br />확인해 보세요.</p>
        <p class="invite-friend-list-overlay__desc">초대한 친구가 구매하면 함께 혜택을 받아요.</p>

        <ul v-if="friends.length" class="invite-friend-list-overlay__list">
          <li
            v-for="(friend, index) in friends"
            :key="index"
            class="invite-friend-list-overlay__item"
          >
            <span class="invite-friend-list-overlay__code">{{ friend.display_name }}</span>
            <span
              class="invite-friend-list-overlay__status"
              :class="statusClass(friend.referral_reward_status)"
            >
              {{ statusLabel(friend.referral_reward_status) }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteFriendListOverlay',
  props: {
    count: {
      type: [Number, String],
      default: 0,
    },
    friends: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    statusLabel(status) {
      if (status === null || status === undefined || status === 'null') return 'null';
      var labels = {
        REGISTERED: '등록완료',
        PURCHASED: '구매완료',
        REWARDED: '지급완료',
        EXPIRED: '기간만료',
      };
      return labels[status] || status;
    },
    statusClass(status) {
      var known = ['REGISTERED', 'PURCHASED', 'REWARDED', 'EXPIRED'];
      // null 등 정의되지 않은 값은 기간만료 디자인 사용
      var key = known.indexOf(status) !== -1 ? status.toLowerCase() : 'expired';
      return 'invite-friend-list-overlay__status--' + key;
    },
  },
}
</script>

<style scoped>
.invite-friend-list-overlay__backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1000;
}

.invite-friend-list-overlay__panel {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 600px;
  height: 100vh;
  background: #FFF;
  box-sizing: border-box;
  z-index: 1001;
  display: flex;
  flex-direction: column;
}

.invite-friend-list-overlay__header {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  box-sizing: border-box;
}

.invite-friend-list-overlay__title {
  margin: 0;
  color: var(--Color-Gray-900, #191F28);
  font-family: Pretendard;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
}

.invite-friend-list-overlay__close {
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;
}

.invite-friend-list-overlay__close-icon {
  width: 16px;
  height: 16px;
  display: block;
  margin: -8px;
}

.invite-friend-list-overlay__content {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
}

/* 제목 아래 41px (헤더 하단 패딩 16px + 25px), 가장 왼쪽 정렬 */
.invite-friend-list-overlay__hifive {
  width: 50px;
  height: 50px;
  display: block;
  margin-top: 25px;
  align-self: flex-start;
}

/* hifive 아이콘 아래 24px */
.invite-friend-list-overlay__lead {
  margin: 24px 0 0 4px;
  color: var(--Color-Text-heavy, #191F28);
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
}

/* lead 텍스트 아래 4px */
.invite-friend-list-overlay__desc {
  margin: 4px 0 0 4px;
  color: var(--Color-Text-strong, #4E5968);
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}

.invite-friend-list-overlay__list {
  list-style: none;
  margin: 16px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px; /* bar 위아래 간격 */
}

.invite-friend-list-overlay__item {
  display: flex;
  padding: 20px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 12px;
  border: 1px solid var(--Color-Divider-default, #E5E8EB);
  background: #FFF;
  box-sizing: border-box;
}

.invite-friend-list-overlay__code {
  color: var(--Color-Text-heavy, #191F28);
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
}

.invite-friend-list-overlay__status {
  display: flex;
  padding: 2px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%; /* 15.6px */
}

/* 등록완료 */
.invite-friend-list-overlay__status--registered {
  background: var(--Color-Status-warning-bg, #FFF3E0);
  color: var(--Color-Status-warning, #FE9800);
}

/* 구매완료 */
.invite-friend-list-overlay__status--purchased {
  background: var(--Color-Decoration-blue-soft, #EFF9FF);
  color: var(--Color-Status-success, #15C47E);
}

/* 지급완료 */
.invite-friend-list-overlay__status--rewarded {
  background: var(--Color-Decoration-blue-soft, #EFF9FF);
  color: var(--Color-Decoration-blue, #008DEF);
}

/* 기간만료 */
.invite-friend-list-overlay__status--expired {
  background: var(--Color-Bg-alternative, #F2F4F6);
  color: var(--Color-Text-strong, #4E5968);
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/InviteFriendListOverlay.vue